<template>
  <!-- 选择参会人 单选、多选人员 -->
  <div :class="[{'permit-nav':mobNavShow}]" class="pad-top-5 pad-operate-btm" :style="cellStyle">
    <p v-show="cellInfo.title" class="pad-top-10 pad-hor pad-btm-10 mar-top-0 mar-btm-0 bg-white">
      <span class="mar-lft-5 mar-rgt-10" @click="preDept">
        <i class="fa" :class="isRoot ? 'fa-times' :'fa-angle-left'" aria-hidden="true"></i>
      </span>
      <span>{{cellInfo.title}}</span>
    </p>

    <!-- 单选 -->
    <van-radio-group v-if="isSingle" v-model="checkUserId">
      <van-cell-group>
        <van-cell v-for="user in userList" :key="user.userId">
          <template #title>
            <van-radio :name="user.userId">
              <span v-show="!showDept" class="color-box mar-rgt-10"
                    :style="`background-color:rgba(${user.headerColor},0.35)`">{{user.name[0]}}</span>
              <span class="custom-title">{{user.name}}（{{user.employeeNumber || "无"}}）</span>
            </van-radio>
          </template>
          <template #label>
            <div v-if="showDept && user.deptNames && user.deptNames.length" class="pad-lft-25">
              <span>{{user.deptNames[0]}}</span>
            </div>
          </template>
        </van-cell>
      </van-cell-group>
    </van-radio-group>
    <!-- 多选 -->
    <van-checkbox-group v-else v-model="checkUserIds">
      <van-cell-group>
        <van-cell v-for="user in userList" :key="user.userId">
          <template #title>
            <van-checkbox :name="user.userId" :ref="cellInfo.deptId+'-users'" shape="square" icon-size="16px">
              <!--:style="'background-color:'+user.headerColor"-->
              <span v-show="!showDept" class="color-box mar-rgt-10"
                    :style="`background-color:rgba(${user.headerColor},0.35)`">{{user.name[0]}}</span>
              <span class="custom-title">{{user.name}}（{{user.employeeNumber || "无"}}）</span>
            </van-checkbox>
          </template>
          <template #label>
            <div v-if="showDept && user.deptNames && user.deptNames.length" class="pad-lft-25">
              <span>{{user.deptNames[0]}}</span>
            </div>
          </template>
        </van-cell>
      </van-cell-group>
    </van-checkbox-group>

    <van-cell-group>
      <!--       :value="checkGroups[dept.id] ? dept.userSum+'人' : ''" -->
      <van-cell v-for="dept in cellInfo.groups" :key="dept.id">
        <template #title>
          <!--<div v-show="!isSingle" class="list-check-box">
            <van-checkbox v-model="checkGroups[dept.id]" :ref="dept.id+'-group'"
                          @change="changeDept($event, dept)"></van-checkbox>
          </div>-->
          <div @click="nextDept(dept)">
            <span class="color-box mar-rgt-10"><i class="fa fa-folder"></i></span>
            <span class="custom-title">{{dept.name}}</span>
          </div>
        </template>
      </van-cell>
    </van-cell-group>

    <!--<div class="text-center pad-all-10">
      <span>- {{cellInfo.userSum}}人 -</span>
    </div>-->
  </div>
</template>

<script>
  import {frontConfirm, checkShowPermit} from "../../../../../tools/utils";

  export default {
    props: {
      cellInfo: Object,
      selectedInfo: Object,
      userList: Array,
      isRoot: Boolean,

      singleUserId: String,
      isSingle: Boolean,
      showDept: Boolean,
    },
    data() {
      return {
        checkGroups: {},
      }
    },
    computed: {
      cellStyle() {
        if (this.isRoot) return {};
        return {
          "z-index": 100,
          position: 'absolute',
          width: '100%',
          // top: '54px'
        }
      },
      checkUserIds: {
        get: function () {
          if (this.isRoot) return this.selectedInfo.userIds.root;
          if (this.cellInfo.deptId === 'filter') return this.selectedInfo.userIds.filter;
          if (this.cellInfo.deptId === 'frequent') {
            return window._.uniq(Object.values(this.selectedInfo.userIds).flat(1))
          }
          return this.selectedInfo.userIds.sub;
        },
        set: function (userIds) {
          this.$emit('change-users', userIds)
        },
      },
      checkUserId: {
        get: function () {
          return this.singleUserId
        },
        set: function (val) {
          this.$emit('change-users', val)
        }
      },
      mobNavShow() {
        const permissionList = this.$store.state.permissionList || [];
        return checkShowPermit(permissionList, this.permitsMap.mobNav)
      }
    },
    watch: {
      'selectedInfo.groupIds.length'(val) {
        const {groupIds = []} = this.selectedInfo;
        // console.log(groupIds);
        Object.keys(this.checkGroups).forEach(id => {
          if (groupIds.includes(id)) return;
          if (this.checkGroups[id]) {
            this.checkGroups = {...this.checkGroups, [id]: false};
            const dom = this.$refs[`${id}-group`];
            if (dom && dom.length) {
              dom[0].toggle(false);
            }
          }
        });
        groupIds.forEach(id => {
          this.checkGroups = {...this.checkGroups, [id]: true};
          const dom = this.$refs[`${id}-group`];
          if (dom && dom.length) {
            dom[0].toggle(true);
          }
        });
      }
    },
    methods: {
      // 选取全部门人员
      changeDept(checked, dept) {
        // console.log({dept, checked});
        if (checked) {
          if (this.selectedInfo.groupIds.includes(dept.id)) return;
          if (dept.userSum < 6) {
            this.toggleDept(dept);
            return;
          }
          if (dept.userSum > 100) {
            vtToast(`此部门下人员数量过大（${dept.userSum}），不支持全选！`);
            this.checkGroups[dept.id] = false;
            return;
          }
          frontConfirm({msg: "是否全选此部门及其下子部门的所有人员？", withCancel: true}, (res) => {
            if (res) {
              this.toggleDept(dept)
            } else {
              this.checkGroups[dept.id] = false;
            }
          });
        } else if (this.selectedInfo.groupIds.includes(dept.id)) {
          this.toggleDept(dept)
        }
      },
      toggleDept(dept) {
        this.$emit('toggle-dept', {
          dept: dept,
          checked: this.checkGroups[dept.id]
        })
      },

      preDept() {
        // console.log('preDept')
        this.$emit('pre-dept', 1)
      },
      nextDept(dept) {
        // console.log(dept);
        this.$emit('next-dept', dept)
      },
    }
  }
</script>

<style scoped>
</style>
